import React from 'react'
import { IoIosArrowDown, IoIosInformationCircleOutline } from 'react-icons/io'
import { MdClose } from 'react-icons/md'
import styles from './forms.module.css'
import { SERVICE_CAPTCHA_BASE_URL, URL_CAPTCHA_IMAGE } from '../../api/captcha'
// import { FaRegCalendarCheck } from 'react-icons/fa'

const Label = label =>
  // the <div> bellow should be replaced by a <React.Fragment> (not avaliable unitl gatsby v2.0)
  {
    if (label.text) {
      return (
        <>
          <label
            className="mb-1 fw-1 db f--1 c-gray--1"
            style={{
              marginBottom: `${label.text === 'Segundo Nombre' && '21px'}`,
            }}
          >
            {label.text}
            {label.required ? (
              <label className="mb-3 fw-1  f--6 c-orange-1"> (*)</label>
            ) : null}
          </label>
        </>
      )
    }
  }

const LabelAhorroYa = label =>
  // the <div> bellow should be replaced by a <React.Fragment> (not avaliable unitl gatsby v2.0)
  {
    if (label.text) {
      return (
        <>
          <label className={`mb-1 fw-1 db f--1 ${styles.labelAhorroYa}`}>
            {label.text}
          </label>
        </>
      )
    }
  }

const TextInput = textInput => (
  <div className={`${textInput.className}`}>
    {textInput.label ? (
      <Label text={textInput.label} required={textInput.required} />
    ) : null}
    <div className="flex items-center">
      {textInput.inputPrefix ? (
        <span className="mr-2">{textInput.inputPrefix}</span>
      ) : null}
      <input
        type={textInput.type || 'text'}
        maxLength={textInput.maxLength}
        name={textInput.name}
        value={textInput.value}
        defaultValue={textInput.defaultValue}
        className={`${styles.input} pv-2 ph-3 w-100`}
        onChange={textInput.onChange}
        disabled={textInput.disabled}
        placeholder={textInput.placeholder}
        {...textInput.attributes}
      />
      {textInput.inputSubfix ? (
        <span className="ml-2">{textInput.inputSubfix}</span>
      ) : null}
    </div>
    {textInput.message ? (
      <div className="f--1 flex mt-2">
        <IoIosInformationCircleOutline className="f-1@lg f-2 mr-1" />
        <p>{textInput.message}</p>
      </div>
    ) : null}
    {textInput.error ? (
      <div className="f--1 flex mt-2" style={{ color: 'red' }}>
        <IoIosInformationCircleOutline className="f-1@lg f-2 mr-1" />
        <p>{textInput.error}</p>
      </div>
    ) : null}
  </div>
)

const Captcha = props => (
  <div style={{ maxWidth: '250px' }} className={`${props.className}`}>
    <Label text="Ingresa el texto de la imagen" />
    {props.ready ? (
      <img
        alt=""
        className="w-100"
        height="78"
        src={`${SERVICE_CAPTCHA_BASE_URL}${URL_CAPTCHA_IMAGE}?captchaSessionId=${props.sessionId}`}
      />
    ) : (
      <div style={{ height: 78 }} />
    )}
    <div>
      <TextInput value={props.value} onChange={props.onChange} />
    </div>
    <a
      href="#"
      onClick={evt => {
        evt.preventDefault()
        props.refreshCaptcha && props.refreshCaptcha()
      }}
      className="c-orange-0 fw-1 f--1"
    >
      Cambiar imagen
    </a>
  </div>
)

const TextArea = TextArea => (
  <div className={`${TextArea.wrapClass} ${TextArea.className}`}>
    {TextArea.label ? (
      <Label text={TextArea.label} required={TextArea.required} />
    ) : null}
    <textarea
      className={`${styles.input} pv-2 ph-3 w-100`}
      type="text"
      name={TextArea.name}
      onChange={TextArea.onChange}
      value={TextArea.children}
      {...TextArea.attributes}
    ></textarea>
    {TextArea.maxLength ? (
      <p className="f--1 right">Máximo {TextArea.maxLength} caracteres</p>
    ) : null}
  </div>
)

//---- CHECKs & RADIOs ----//
const Radio = props => (
  <label className={`${styles.InputPress} ${props.className}`}>
    <input
      name={props.name}
      checked={props.checked}
      className={styles.inputRadCheck}
      value={props.value}
      onChange={props.onChange}
      type="radio"
    />
    <span className={styles.radio}></span>
    <span className={styles.fakelabel}>{props.label}</span>
  </label>
)

const RadCheck = radCheck => (
  <label
    className={
      styles.InputPress + ' ' + radCheck.wrapClass + ' ' + radCheck.className
    }
  >
    <input
      id={radCheck.id || undefined}
      className={styles.inputRadCheck}
      type={radCheck.type}
      name={radCheck.name}
      checked={radCheck.check || null}
      defaultValue={radCheck.val}
      onChange={event => radCheck.onChange(event.target.value)}
      {...radCheck.attributes}
    />
    <span
      className={radCheck.type === 'radio' ? styles.radio : styles.checkbox}
    ></span>
    <span className={styles.fakelabel}>{radCheck.label}</span>
  </label>
)

const RadCheckE = radCheck => (
  <label
    className={
      styles.InputPress + ' ' + radCheck.wrapClass + ' ' + radCheck.className
    }
  >
    <input
      id={radCheck.id || undefined}
      className={styles.inputRadCheck}
      type={radCheck.type}
      name={radCheck.name}
      checked={radCheck.accept ? radCheck.check : false}
      defaultValue={radCheck.val}
      onChange={event => radCheck.onChange(event.target.value)}
      {...radCheck.attributes}
    />
    <span
      className={radCheck.type === 'radio' ? styles.radio : styles.checkbox}
    ></span>
    <span className={styles.fakelabel}>{radCheck.label}</span>
  </label>
)

const Select = select => (
  <div className={`${select.className}`}>
    {select.label ? (
      <Label text={select.label} required={select.required} />
    ) : null}
    <div className={styles.input}>
      <IoIosArrowDown className={styles.arrowSelect} />
      <select
        className={` ${styles.select}`}
        selected={select.value}
        value={select.value}
        disabled={select.disabled}
        onChange={event => select.onChange(event.target.value)}
      >
        {select.placeholder ? (
          <option value="" disabled selected hidden>
            {select.placeholder}
          </option>
        ) : (
          ''
        )}
        {select.items.map((item, index) => (
          <option key={index} value={item.value} disabled={item.disabled}>
            {item.name}
          </option>
        ))}
      </select>
    </div>
    {select.error ? (
      <div className="f--1 flex mt-2" style={{ color: 'red' }}>
        <IoIosInformationCircleOutline className="f-1@lg f-2 mr-1" />
        <p>{select.error}</p>
      </div>
    ) : null}
  </div>
)

const SelectAhorroYa = select => (
  <div className={`${select.className}`}>
    {select.label ? (
      <LabelAhorroYa text={select.label} required={select.required} />
    ) : null}
    <div className={styles.relative}>
      <select
        className={` ${styles.selectAhorroYa}`}
        selected={select.value}
        value={select.value}
        onChange={event => select.onChange(event.target.value)}
      >
        {select.placeholder ? (
          <option value="" disabled selected hidden>
            {select.placeholder}
          </option>
        ) : (
          ''
        )}
        {select.items.map((item, index) => (
          <option key={index} value={item.value} disabled={item.disabled}>
            {item.name}
          </option>
        ))}
      </select>
      <IoIosArrowDown className={styles.arrowSelect} color='#00A499' />
    </div>
  </div>
)

const ComboForm = comboForm => (
  <div className={`${comboForm.className}`}>
    {comboForm.label ? (
      <Label text={comboForm.label} required={TextArea.required} />
    ) : null}
    <div
      className={`${styles.comboform}  ${
        styles['comboform_' + comboForm.align]
      } ${styles['comboform_lay_' + comboForm.proportion]}`}
    >
      {comboForm.children}
    </div>
  </div>
)

class SingleFile extends React.Component {
  handleChange = evt => {
    const { onChangeFile } = this.props
    if (onChangeFile) {
      onChangeFile(evt)
    }
  }

  handleClear = file => {
    const { onClearFile } = this.props
    if (onClearFile) {
      onClearFile(file, this.props.name)
    }
  }

  render() {
    const { label, file, className, accept, name } = this.props

    return (
      <React.Fragment>
        {label ? <Label text={label} required={TextArea.required} /> : null}
        <div className={`${styles.file} ${className}`}>
          <ul className={styles.send}>
            {file ? (
              <li className={styles.sendItem} key={file.name}>
                {file.name}
                <button className="ml-2" onClick={() => this.handleClear(file)}>
                  <MdClose />
                </button>
              </li>
            ) : null}
          </ul>
          {!file ? (
            <div className={`${styles.file_fakeButton} mt-3`}>
              <p className={styles.file_label}>Subir archivo</p>
              <input
                type="file"
                name={name}
                accept={accept}
                className={styles.file_upload}
                onChange={this.handleChange}
              />
            </div>
          ) : null}
        </div>
      </React.Fragment>
    )
  }
}

class File extends React.Component {
  state = {
    files: [],
  }
  render() {
    // TODO: Delete this console.log(this.state.files)
    return (
      <React.Fragment>
        {this.props.label ? (
          <Label text={this.props.label} required={TextArea.required} />
        ) : null}
        <div className={`${styles.file} ${this.props.className}`}>
          <ul className={styles.send}>
            {this.state.files.map((item, index) => (
              <li className={styles.sendItem} key={item.name}>
                {item.name}
                <button
                  className="ml-2"
                  onClick={() =>
                    this.setState(prevState => {
                      let arrr = prevState.files
                      arrr.splice(index, index + 1)
                      return { files: arrr }
                    })
                  }
                >
                  <MdClose />
                </button>
              </li>
            ))}
          </ul>
          {this.props.maxUploadFiles > this.state.files.length ? (
            <div className={`${styles.file_fakeButton} mt-3`}>
              <p className={styles.file_label}>
                {this.state.files.length > 0
                  ? 'Subir más archivos'
                  : 'Subir archivos'}
              </p>
              <input
                type="file"
                className={styles.file_upload}
                onChange={e => {
                  let fileLists = e.target.files[0]
                  this.setState(prevState => ({
                    files: [...prevState.files, fileLists],
                  }))
                }}
              />
            </div>
          ) : null}
        </div>
      </React.Fragment>
    )
  }
}

File.defaultProps = {
  className: '',
  maxUploadFiles: 10,
}

TextInput.defaultProps = {
  className: '',
  placeholder: '',
}

Select.defaultProps = {
  className: '',
  onChange: () => {},
}

RadCheck.defaultProps = {
  className: '',
  onChange: () => {},
}

ComboForm.defaultProps = {
  className: '',
  proportion: '1_1',
  align: 'bottom',
}

export {
  TextInput,
  RadCheck,
  RadCheckE,
  Select,
  SelectAhorroYa,
  Label,
  LabelAhorroYa,
  Captcha,
  TextArea,
  File,
  SingleFile,
  ComboForm,
  Radio,
}
